import { Backdrop, CircularProgress } from "@wealthx/ui";
import PropTypes from "prop-types";

const LoadingBackdrop = ({ isOpen = true, handleClose = () => {} }) => {
  return (
    <Backdrop className="loading-modal" open={isOpen} onClick={handleClose}>
      <div style={{ textAlign: "center" }}>
        <CircularProgress color="inherit" />
        <div>Loading Data...</div>
      </div>
    </Backdrop>
  );
};

LoadingBackdrop.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default LoadingBackdrop;
